module.exports = __webpack_public_path__ + "img/servier.f007034b.svg";